var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2109 4.39812C16.1933 4.81361 17.0756 5.40851 17.8334 6.1663C18.5913 6.92412 19.1863 7.80645 19.6018 8.78878C20.0319 9.80563 20.25 10.886 20.25 12C20.25 13.114 20.0319 14.1944 19.6018 15.2112C19.1863 16.1936 18.5913 17.0759 17.8335 17.8337C17.0756 18.5915 16.1933 19.1864 15.2109 19.6019C14.1941 20.0319 13.1138 20.25 12 20.25C10.8862 20.25 9.80587 20.0319 8.78909 19.6019C7.80673 19.1864 6.92439 18.5915 6.16656 17.8337C5.40871 17.0759 4.81374 16.1936 4.39822 15.2112C3.9681 14.1944 3.75 13.1139 3.75 12C3.75 10.886 3.96809 9.80562 4.39822 8.78879C4.81374 7.80643 5.40871 6.92411 6.16656 6.16629C6.92438 5.4085 7.80673 4.8136 8.78908 4.39812C9.80587 3.96806 10.8862 3.75 12 3.75C13.1138 3.75 14.1941 3.96805 15.2109 4.39812Z",
    fill: "#4C4C4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 11.9132H12.45L12.45 7.86328H11.5499L11.5499 11.9132H7.5L7.5 12.8133H11.5499L11.5499 16.8633H12.45L12.45 12.8133H16.5L16.5 11.9132Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon_add.897025b411046c1e7ad61f4a1de99e12.svg";
export { ForwardRef as ReactComponent };